import {createSelector} from 'reselect';

import {LayoutsCountPageState} from './layoutsCountSlice';

const selectLayoutsCountState = (state: LayoutsCountPageState) => state.userPage.tabs.content.layoutsCount;

export const makeSelectLayoutsCountByUserId = (userId: number) =>
    createSelector(
        [selectLayoutsCountState],
        layoutsCountState => {
            const userLayouts = layoutsCountState.countsByUserId[userId];
            return userLayouts || {
                total: 0,
                status: 'idle' as const,
                error: undefined,
                receivedAt: undefined,
            };
        },
    );

export const selectLayoutsCountReceivedAt = (state: LayoutsCountPageState, userId: number) => {
    const userLayouts = state.userPage.tabs.content.layoutsCount.countsByUserId[userId];
    return userLayouts?.receivedAt;
};
